import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';

import {CountyApi, UserAccountApi, WardApi} from '../../../../../../theme/services/sdk';
import {BaToastNotificationService} from '../../../../../../theme/services/baToastNotification'
import {WardComponent} from "../../ward.component";


@Component({
  selector: 'ward-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  providers: [UserAccountApi, CountyApi, BaToastNotificationService, WardApi]
})
export class WardForm {

  public form: FormGroup;
  public name: AbstractControl;
  public county_id: AbstractControl;
  public submitted: boolean = false;
  public sub_county_id: AbstractControl;

  county_list: Object;
  ward: Object;
  sub_county_list: Object;

  constructor(fb: FormBuilder, protected user: UserAccountApi, protected wardService: WardApi, protected county: CountyApi, private route: ActivatedRoute, private router: Router, private toast: BaToastNotificationService, private data: WardComponent) {
    this.form = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'county_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      'sub_county_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])]
    });

    this.name = this.form.controls['name'];
    this.county_id = this.form.controls['county_id'];
    this.sub_county_id = this.form.controls['sub_county_id'];
    this.user.isAuthenticated() ? false : this.router.navigate(['login']);
  }

  ngOnInit() {
    this.county.find().subscribe((res) => {
      this.county_list = res;
    })
    this.data.ward.subscribe(data => {
      this.ward = data
      if (this.ward['id']) {
        console.log(this.ward);
        this.county.findById(this.ward['county_id'], {
            include: ['subCounties']
          }
        ).subscribe((res) => {
          this.sub_county_list = res['subCounties'];
          this.sub_county_id.setValue(this.ward['sub_county_id']);
        });
      }


    });
  }

  public onSubmit(values: Object): void {
    this.submitted = true;
    if (this.form.valid) {
      let self = this;
      let co;

      if (this.ward['id']) {


        co = this.wardService.upsert({
          id: this.ward['id'],
          name: self.name['value'],
          county_id: self.county_id['value'],
          sub_county_id: self.sub_county_id['value'],
        })

      } else {
        co = this.wardService.create({
          name: self.name['value'],
          county_id: self.county_id['value'],
          sub_county_id: self.sub_county_id['value'],
        })
      }

      co.subscribe(res => {
        let msg: string;
        this.data.refresh();
        this.form.reset();
        if (this.ward['id']) {
          this.data.cancelSelected();
          msg = 'Record updated';
        } else {
          msg = 'New ward added';
        }
        this.toast.success({
          heading: 'Success',
          text: msg,
          stack: 3
        });
      }, err => {
        this.toast.error({
          heading: err.name,
          text: err.message,
          stack: 3
        });
        console.log(err);
      });
    }
  }

  onCountyChange() {
    this.county.findById(this.county_id['value'], {
      include: ['subCounties']
    }).subscribe((res) => {
      console.log(res);
      this.sub_county_list = res['subCounties'];
    });
  }


  cancelSelected() {
    this.data.cancelSelected();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/wards/components/form/form.component.ts